import { Link } from "react-router-dom";

import { BrandLockup } from "@/components/brand/BrandLockup";
import { NotificationBell } from "./NotificationBell";
import { useNotificationBell } from "./useNotificationBell";

/**
 * TopBar — desktop 56px header strip.
 *
 * Per `DESIGN.md §13`: 56px height. Glass-2 backdrop optional (skipped here
 * since PageHero provides the primary glass surface). Bell icon lives in
 * top-right per the "no FAB" rule (AGENTS §3 #15).
 *
 * W36.1: same dead-link removal as `MobileHeader` — one shared
 * `NotificationBell`, one shared piece of sheet state, two viewports.
 */
export function TopBar() {
  const bell = useNotificationBell();

  return (
    <header
      data-component="TopBar"
      className="h-14 hairline-b flex items-center justify-between px-5"
    >
      {/* `min-h-11 min-w-11 px-1 -mx-1` — W46.0. The desktop wordmark is the
          *same defect the mobile header had* (`MobileHeader.tsx`, fixed earlier
          this round): a text link whose box is its type, so it measured
          **49.9 × 26** on every desktop route. It was invisible to the mobile
          sweep because `TopBar` only renders above the breakpoint — which is the
          general shape of this class of bug, the same reason `KanbanBoard` hid
          a crash from every mobile audit.
          `px-1 -mx-1` keeps the mark on the original left edge, so only the
          target grows.

          W46.1 (ADR-0129) swapped the bare `heshe` for `BrandLockup` — same
          accessible name, because the component keeps the wordmark as live text
          and marks the mark `alt=""`. `justify-center` on a lockup centres the
          mark+word pair inside the 44px target; `items-center` alone would top-
          align the taller of the two and leave the mark looking lifted. */}
      <Link
        to="/dashboard"
        className="press font-display text-h3 text-ink-1 inline-flex min-h-11 min-w-11 items-center justify-center px-1 -mx-1"
      >
        <BrandLockup size="sm" />
      </Link>
      <NotificationBell open={bell.open} onOpenChange={bell.onOpenChange} />
    </header>
  );
}
